// @ts-nocheck

export type TicketGetWithTicketCommentsContactFromTenant = typeof TicketGetWithTicketCommentsContactFromTenant[keyof typeof TicketGetWithTicketCommentsContactFromTenant];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithTicketCommentsContactFromTenant = {
  true: 'true',
  false: 'false',
} as const;
